<script setup>
import { ref } from 'vue'
import { DocumentDownloadIcon } from "@heroicons/vue/outline"
import fileDownload from 'js-file-download'

const props = defineProps({
	id: {
		type: Number,
		required: true,
	},
})

const downloadButton = ref(null)

function downloadFile() {
    downloadButton.value.waitFor(
        axios.get(`/api/files/${props.id.value}`)
        .then(response => {
			axios.get(response.data.url, {
				responseType: 'blob',
			}).then(res => {
				fileDownload(res.data, response.data.name)
			})
		})
    )
}

</script>

<template>
	<PromiseButton
		v-bind="$attrs"
		ref="downloadButton"
		@click="downloadFile"
	>
		<DocumentDownloadIcon class="w-4 mr-2" /> Download
	</PromiseButton>
</template>